import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';

const ProtectedRoute: React.FC = () => {
  const token = Cookies.get('token');

  // Ha nincs token, átirányítjuk a felhasználót a bejelentkezési oldalra
  if (!token) {
    return <Navigate to="/login" />;
  }

  // Ha van token, megjelenítjük a gyermek komponenseket
  return <Outlet />;
};

export default ProtectedRoute;